import React from "react";
import { Card, CardContent } from "../ui/card";

interface GutHealthScoreCardProps {
  foodScore: number;
  foodMaxScore: number;
  lifestyleScore: number;
  lifestyleMaxScore: number;
}

const GutHealthScoreCard: React.FC<GutHealthScoreCardProps> = ({
  foodScore,
  foodMaxScore,
  lifestyleScore,
  lifestyleMaxScore,
}) => {
  const today = new Date();
  const dateStr = `Today, ${today.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  })}`;

  const renderDonut = (
    value: number,
    max: number,
    colorClass: string,
    bgClass: string,
    label: string,
    subLabel: string
  ) => {
    const radius = 38; // Radius of the circle
    const stroke = 8; // Stroke width
    const normalizedRadius = radius - stroke / 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const progress = Math.min((value / max) * 100, 100);
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
      <div className="flex flex-col items-center">
        <div className="relative flex h-24 w-24 items-center justify-center">
          <svg
            height={radius * 2}
            width={radius * 2}
            className="rotate-[-90deg]"
          >
            <circle
              className={bgClass}
              strokeWidth={stroke}
              fill="transparent"
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />
            <circle
              className={colorClass}
              strokeWidth={stroke}
              strokeDasharray={`${circumference} ${circumference}`}
              style={{ strokeDashoffset }}
              strokeLinecap="round"
              fill="transparent"
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />
          </svg>
          <div
            className={`absolute text-3xl font-bold ${colorClass.replace(
              "stroke-",
              "text-"
            )}`}
          >
            {Math.round(value)}
          </div>
        </div>
        <div className="mt-2 text-center">
          <div className="text-base font-bold text-foreground">{label}</div>
          <div className="text-xs text-muted-foreground">{subLabel}</div>
        </div>
      </div>
    );
  };

  return (
    <Card className="h-full bg-card shadow-sm">
      <CardContent className="flex h-full flex-col justify-between p-5">
        <div className="mb-4">
          <h3 className="font-bold text-foreground">Bite Balance</h3>
          <p className="text-xs text-muted-foreground">{dateStr}</p>
        </div>

        <div className="flex flex-1 items-center justify-around gap-4">
          {renderDonut(
            foodScore,
            foodMaxScore || 80,
            "stroke-blue-500",
            "stroke-blue-100 dark:stroke-blue-900",
            "Gut Health",
            "Meals & nutrition"
          )}
          {renderDonut(
            lifestyleScore,
            lifestyleMaxScore || 20,
            "stroke-green-500",
            "stroke-green-100 dark:stroke-green-900",
            "Lifestyle",
            "Fitbit data"
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default GutHealthScoreCard;
